/**
 * The product cards on the empty cart arc (snippets/cart-empty-arc.liquid) are decoration: the arc is hidden from
 * screen readers, so its links and buttons must not take keyboard focus either. They stay clickable with a pointer.
 * This runs every time the arc is put in the page, including when the cart drawer re-renders itself.
 *
 * Hovering the arc with a mouse slows the turning wheel to 25% of its speed instead of stopping it. Only the playback
 * rate of the running CSS animation changes, so the cards keep their place and do not jump.
 */
const HOVER_RATE = 0.25;

class CartEmptyArc extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('a, button, input, select, [tabindex]').forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });

    this.addEventListener('pointerenter', this.#onEnter);
    this.addEventListener('pointerleave', this.#onLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.#onEnter);
    this.removeEventListener('pointerleave', this.#onLeave);
  }

  #onEnter = (event) => {
    if (event.pointerType === 'mouse') this.#setRate(HOVER_RATE);
  };

  #onLeave = (event) => {
    if (event.pointerType === 'mouse') this.#setRate(1);
  };

  // The wheel's CSS animation: none with reduced motion, then this does nothing
  #setRate(rate) {
    const animation = this.querySelector('.cart-empty-arc__wheel')?.getAnimations()[0];
    if (!animation) return;

    // Setting playbackRate keeps the animation's current time, so the wheel only changes speed
    animation.playbackRate = rate;
  }
}

if (!customElements.get('cart-empty-arc')) {
  customElements.define('cart-empty-arc', CartEmptyArc);
}
